import { localhost,development, staging, production} from './env';

export default (() => {
  switch (process.env.REACT_APP_ENV) {

    case 'local':
    case 'local ':
    case 'localhost':
      return localhost;

    case 'dev':
    case 'dev ':
    case 'development':
      return development;

    case 'stag':
    case 'stag ':
    case 'staging':
      return staging;

      case 'prod':
        case 'prod ':
        case 'production':
          return production;

    default:
      return production;
  }
})()
